import React from 'react';

import { Container, Title, GoBackButton } from './styles';

interface Props {
  title: string;
  onClose: () => void;
}

const SubMenuHeader = ({ title, onClose }: Props) => (
  <Container>
    <GoBackButton onClick={onClose}>
      <img src="/corporate/images/back-arrow.svg" alt="back-arrow" />
    </GoBackButton>

    <Title>{title}</Title>
  </Container>
);

export default SubMenuHeader;
